import FrmAccessDeviceActivity from '@/pages/production/accessDevices/FrmAccessDeviceActivity.vue';
import FrmAccessDeviceDetails from '@/pages/production/accessDevices/FrmAccessDeviceDetails.vue';
import FrmProductiveActivityLine from '@/pages/production/productionLines/FrmProductiveActivityLine.vue';
import FrmCountBoxPerWorkerHome from '@/pages/production/individualProduction/countBoxPerWorker/FrmCountBoxPerWorkerHome.vue';
import FrmCountBoxPerWorkerLines from '@/pages/production/individualProduction/countBoxPerWorker/FrmCountBoxPerWorkerLines.vue';
import FrmDumpMerchandiseConfiguration from '@/pages/production/traceability/dumpAndRecoverMerchandise/FrmDumpMerchandiseConfiguration.vue';
import FrmDumpMerchandiseLogisticUnitHome from '@/pages/production/traceability/dumpAndRecoverMerchandise/FrmDumpMerchandiseLogisticUnitHome.vue';
import FrmSummaryOfDumpsByFamily from '@/pages/production/traceability/dumpAndRecoverMerchandise/FrmSummaryOfDumpsByFamily.vue';
import FrmDetailDumpMerchandise from '@/pages/production/traceability/dumpAndRecoverMerchandise/dump/FrmDetailDumpMerchandise.vue';
import FrmDumpMerchandiseSplitView from '@/pages/production/traceability/dumpAndRecoverMerchandise/dump/FrmDumpMerchandiseSplitView.vue';
import FrmReadingDumpMerchandiseLogisticUnit from '@/pages/production/traceability/dumpAndRecoverMerchandise/dump/FrmReadingDumpMerchandiseLogisticUnit.vue';
import FrmDumpMerchandiseULView from '@/pages/production/traceability/dumpAndRecoverMerchandise/dump/FrmDumpMerchandiseULView.vue';
import FrmRetrieveOverturnedMerchandise from '@/pages/production/traceability/dumpAndRecoverMerchandise/retrieve/FrmRetrieveOverturnedMerchandise.vue';
import FrmRetrieveOverturnedMerchandiseView from '@/pages/production/traceability/dumpAndRecoverMerchandise/retrieve/FrmRetrieveOverturnedMerchandiseView.vue';
import FrmRetrieveOverturnedMerchandiseULView from '@/pages/production/traceability/dumpAndRecoverMerchandise/retrieve/FrmRetrieveOverturnedMerchandiseULView.vue';
import FrmRetrieveOverturnedMerchandiseSplitView from '@/pages/production/traceability/dumpAndRecoverMerchandise/retrieve/FrmRetrieveOverturnedMerchandiseSplitView.vue';
import FrmGenerateDumpDiscardsPallet from '@/pages/production/traceability/dumpAndRecoverMerchandise/discards/FrmGenerateDumpDiscardsPallet.vue';
import FrmManageProductionLines from '@/pages/production/traceability/manageProductionLines/FrmManageProductionLines.vue'; // Administrar planificación lineas de producción.
import FrmManageProductionOutputs from '@/pages/production/traceability/manageProductionOutputs/FrmManageProductionOutputs.vue'; // Administrar salidas de paletizado.
import FrmLocationControlHome from '@/pages/production/traceability/locationControl/FrmLocationControlHome.vue';
import FrmEditionSelectionPreparationCalibration from '@/pages/production/traceability/palletizing/FrmEditionSelectionPreparationCalibration.vue';
import FrmFamilyPreparationTemplatesModels from '@/pages/production/traceability/palletizing/FrmFamilyPreparationTemplatesModels.vue';
import FrmLineItemEditing from '@/pages/production/traceability/palletizing/FrmLineItemEditing.vue';
import FrmMultipointPalletizing from '@/pages/production/traceability/palletizing/FrmMultipointPalletizing.vue';
import FrmNewPalletWithoutPlannedOrder from '@/pages/production/traceability/palletizing/FrmNewPalletWithoutPlannedOrder.vue';
import FrmPalletizingHome from '@/pages/production/traceability/palletizing/FrmPalletizingHome.vue';
import FrmPlannedOrdersPalletizingPoint from '@/pages/production/traceability/palletizing/FrmPlannedOrdersPalletizingPoint.vue';
import FrmBoxReadingsPalletizing from '@/pages/production/individualProduction/palletizingWithBoxReadings/FrmBoxReadingsPalletizing.vue';
import FrmPicking from '@/pages/production/commercialization/picking/FrmPicking.vue';
import FrmKiloRecord from '@/pages/production/traceability/FrmKiloRecord.vue';
import FrmProductionPlanningStatus from '@/pages/production/productionLines/productionLinesManagement/FrmProductionPlanningStatus.vue';
import FrmProductionPlanningStatusComplete from '@/pages/production/productionLines/productionLinesManagement/FrmProductionPlanningStatusComplete.vue';
import FrmWeighingSystem from '@/pages/production/traceability/palletizing/FrmWeighingSystem.vue';

import productionPlannerRoutes from '../productionPlanner/routes';

export default [
  {
    path: '/production/accessDevice/accessDeviceActivity',
    component: FrmAccessDeviceActivity,
  },
  {
    path: '/production/accessDevice/accessDeviceDetails',
    component: FrmAccessDeviceDetails,
  },
  {
    path: '/production/productionLines/productiveActivityLine',
    component: FrmProductiveActivityLine,
  },
  {
    path: '/production/countBoxPerWorker/FrmCountBoxPerWorkerLines',
    component: FrmCountBoxPerWorkerLines,
  },
  {
    path: '/production/traceability/frmKiloRecord',
    component: FrmKiloRecord,
  },
  /* Producción Individual */
  {
    path: '/production/individualProduction/countBoxPerWorker/FrmCountBoxPerWorkerHome',
    component: FrmCountBoxPerWorkerHome,
  },
  {
    path: '/production/individualProduction/palletizingWithBoxReadings/FrmBoxReadingsPalletizing',
    component: FrmBoxReadingsPalletizing,
  },
  /* Trazabilidad */
  {
    path: '/production/traceability/dumpAndRecoverMerchandise/FrmDumpMerchandiseConfiguration',
    component: FrmDumpMerchandiseConfiguration,
  },
  {
    path: '/production/traceability/dumpAndRecoverMerchandise/FrmDumpMerchandiseLogisticUnitHome',
    component: FrmDumpMerchandiseLogisticUnitHome,
  },
  {
    path: '/production/traceability/dumpAndRecoverMerchandise/FrmSummaryOfDumpsByFamily',
    component: FrmSummaryOfDumpsByFamily,
  },
  {
    path: '/production/traceability/dumpAndRecoverMerchandise/dump/FrmDetailDumpMerchandise',
    component: FrmDetailDumpMerchandise,
  },
  {
    path: '/production/traceability/dumpAndRecoverMerchandise/dump/FrmDumpMerchandiseSplitView',
    component: FrmDumpMerchandiseSplitView,
  },
  {
    path: '/production/traceability/dumpAndRecoverMerchandise/dump/FrmReadingDumpMerchandiseLogisticUnit',
    component: FrmReadingDumpMerchandiseLogisticUnit,
  },
  {
    path: '/production/traceability/dumpAndRecoverMerchandise/dump/FrmDumpMerchandiseULView',
    component: FrmDumpMerchandiseULView,
  },

  {
    path: '/production/traceability/dumpAndRecoverMerchandise/retrieve/FrmRetrieveOverturnedMerchandise',
    component: FrmRetrieveOverturnedMerchandise,
  },
  {
    path: '/production/traceability/dumpAndRecoverMerchandise/retrieve/FrmRetrieveOverturnedMerchandiseView',
    component: FrmRetrieveOverturnedMerchandiseView,
  },
  {
    path: '/production/traceability/dumpAndRecoverMerchandise/retrieve/FrmRetrieveOverturnedMerchandiseULView',
    component: FrmRetrieveOverturnedMerchandiseULView,
  },
  {
    path: '/production/traceability/dumpAndRecoverMerchandise/retrieve/FrmRetrieveOverturnedMerchandiseSplitView',
    component: FrmRetrieveOverturnedMerchandiseSplitView,
  },

  {
    path: '/production/traceability/dumpAndRecoverMerchandise/FrmGenerateDumpDiscardsPallet',
    component: FrmGenerateDumpDiscardsPallet,
  },
  {
    path: '/production/traceability/manageProductionOutputs/FrmManageProductionOutputs',
    component: FrmManageProductionOutputs,
  },
  {
    path: '/production/traceability/manageProductionLines/FrmManageProductionLines',
    component: FrmManageProductionLines,
  },
  {
    path: '/production/traceability/palletizing/FrmPalletizingHome',
    component: FrmPalletizingHome,
  },
  {
    path: '/production/traceability/palletizing/FrmEditionSelectionPreparationCalibration',
    component: FrmEditionSelectionPreparationCalibration,
  },
  {
    path: '/production/traceability/palletizing/FrmFamilyPreparationTemplatesModels',
    component: FrmFamilyPreparationTemplatesModels,
  },
  {
    path: '/production/traceability/palletizing/FrmLineItemEditing',
    component: FrmLineItemEditing,
  },
  {
    path: '/production/traceability/palletizing/FrmMultipointPalletizing',
    component: FrmMultipointPalletizing,
  },
  {
    path: '/production/traceability/palletizing/FrmNewPalletWithoutPlannedOrder',
    component: FrmNewPalletWithoutPlannedOrder,
  },
  {
    path: '/production/traceability/palletizing/FrmPlannedOrdersPalletizingPoint',
    component: FrmPlannedOrdersPalletizingPoint,
  },
  {
    path: '/production/traceability/locationControl/FrmLocationControlHome',
    component: FrmLocationControlHome,
  },
  {
    path: '/production/commercialization/picking/FrmPicking',
    component: FrmPicking,
  },
  {
    path: '/production/roductionLines/productionLinesManagement/FrmProductionPlanningStatus',
    component: FrmProductionPlanningStatus,
  },
  {
    path: '/production/productionLines/productionLinesManagement/FrmProductionPlanningStatusComplete',
    component: FrmProductionPlanningStatusComplete,
  },
  {
    path: '/production/traceability/palletizing/FrmWeighingSystem',
    component: FrmWeighingSystem,
  },

  ...productionPlannerRoutes,
];
